import { render, staticRenderFns } from "./AscRequiredLabel.vue?vue&type=template&id=602ec613&"
import script from "./AscRequiredLabel.vue?vue&type=script&lang=js&"
export * from "./AscRequiredLabel.vue?vue&type=script&lang=js&"
import style0 from "./AscRequiredLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports